import Link from '../Link';
import { formatDate, isDatePast } from '../../../date';
import { numberFormat } from '../../../numeral';
import styles from '../../../../sass/status.module.scss';
function ExamDecision(_ref) {
  var title = _ref.title,
    number = _ref.number,
    type = _ref.type,
    history = _ref.history;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-score-metric"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-score-label"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "cb-score-value cb-font-weight-medium"
  }, /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/students?oe=".concat(type),
    className: "cb-btn cb-btn-naked cb-no-padding cb-no-outline",
    style: {
      fontSize: '2rem'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "View all students with ", type.toLowerCase(), " for exam intent"), numberFormat(number))));
}
function EditLink(_ref2) {
  var describedby = _ref2.describedby,
    history = _ref2.history;
  return /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/settings?scroll=examDecisionsPanel",
    "aria-describedby": describedby
  }, "edit");
}
function StandardDecision(_ref3) {
  var standardExamDecisionDeadline = _ref3.standardExamDecisionDeadline,
    secondSemesterExamDecisionDeadline = _ref3.secondSemesterExamDecisionDeadline,
    history = _ref3.history;
  var formattedStandardDecisionDate = formatDate(standardExamDecisionDeadline);
  var id = 'standardDecision';
  var editLink = /*#__PURE__*/React.createElement(EditLink, {
    describedby: id,
    history: history
  });
  if (isDatePast(standardExamDecisionDeadline)) return /*#__PURE__*/React.createElement("p", {
    id: id
  }, "Decision deadline, ", /*#__PURE__*/React.createElement("strong", null, formattedStandardDecisionDate), ", has passed ", editLink);
  return /*#__PURE__*/React.createElement("p", {
    id: id
  }, secondSemesterExamDecisionDeadline ? 'Standard decision deadline: ' : 'Decision deadline: ', /*#__PURE__*/React.createElement("strong", null, formattedStandardDecisionDate), " ", editLink);
}
function SecondSemesterDecision(_ref4) {
  var secondSemesterExamDecisionDeadline = _ref4.secondSemesterExamDecisionDeadline,
    history = _ref4.history;
  var formattedSecondSemesterDate = formatDate(secondSemesterExamDecisionDeadline);
  var id = 'secondSemesterDecision';
  var editLink = /*#__PURE__*/React.createElement(EditLink, {
    describedby: id,
    history: history
  });
  if (isDatePast(secondSemesterExamDecisionDeadline)) return /*#__PURE__*/React.createElement("p", {
    id: id
  }, "Second semester deadline, ", /*#__PURE__*/React.createElement("strong", null, formattedSecondSemesterDate), ", has passed", ' ', editLink);
  return /*#__PURE__*/React.createElement("p", {
    id: id
  }, "Second semester decision deadline: ", /*#__PURE__*/React.createElement("strong", null, formattedSecondSemesterDate), " ", editLink);
}
function ExamRegistrations(_ref5) {
  var _ref5$numberTakingExa = _ref5.numberTakingExam,
    numberTakingExam = _ref5$numberTakingExa === void 0 ? 0 : _ref5$numberTakingExa,
    _ref5$numberNotTaking = _ref5.numberNotTakingExam,
    numberNotTakingExam = _ref5$numberNotTaking === void 0 ? 0 : _ref5$numberNotTaking,
    _ref5$numberUndecided = _ref5.numberUndecided,
    numberUndecided = _ref5$numberUndecided === void 0 ? 0 : _ref5$numberUndecided,
    _ref5$numberUnused = _ref5.numberUnused,
    numberUnused = _ref5$numberUnused === void 0 ? 0 : _ref5$numberUnused,
    standardExamDecisionDeadline = _ref5.standardExamDecisionDeadline,
    secondSemesterExamDecisionDeadline = _ref5.secondSemesterExamDecisionDeadline,
    numberClassesExamDecisionsNotConfirmed = _ref5.numberClassesExamDecisionsNotConfirmed,
    history = _ref5.history;
  var teacherConfirmId = 'teacherNotConfirmed';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Taking",
    number: numberTakingExam,
    type: "YES",
    history: history
  }), /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Not Taking",
    number: numberNotTakingExam,
    type: "NO",
    history: history
  }), /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Undecided",
    number: numberUndecided,
    type: "UNDECIDED",
    history: history
  }), numberUnused ? /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Unused",
    number: numberUnused,
    type: "UNUSED",
    history: history
  }) : null), standardExamDecisionDeadline ? /*#__PURE__*/React.createElement(StandardDecision, {
    standardExamDecisionDeadline: standardExamDecisionDeadline,
    secondSemesterExamDecisionDeadline: secondSemesterExamDecisionDeadline,
    history: history
  }) : null, secondSemesterExamDecisionDeadline ? /*#__PURE__*/React.createElement(SecondSemesterDecision, {
    secondSemesterExamDecisionDeadline: secondSemesterExamDecisionDeadline,
    history: history
  }) : null, numberClassesExamDecisionsNotConfirmed !== undefined && numberClassesExamDecisionsNotConfirmed !== null ? /*#__PURE__*/React.createElement("p", {
    id: teacherConfirmId
  }, "Not teacher confirmed:", ' ', /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/courses?tcon=N",
    "aria-describedby": teacherConfirmId
  }, /*#__PURE__*/React.createElement("strong", null, numberFormat(numberClassesExamDecisionsNotConfirmed)))) : null);
}
export default ExamRegistrations;